import { Link, useLocation } from "@tanstack/react-router";

import { useIsSuperAdmin } from "../../access/AccessProvider";
import { sectionNavItemClassName } from "../app-shell/sectionNavigation";

import { resolveVisibleSettingsNavItems } from "./settingsNav";

export function SettingsCategoryNav() {
  const pathname = useLocation({ select: (location) => location.pathname });
  const isSuperAdmin = useIsSuperAdmin();
  const items = resolveVisibleSettingsNavItems({ isSuperAdmin });

  return (
    <nav aria-label="Settings categories" className="min-w-0">
      <ul className="flex flex-col gap-0.5">
        {items.map((item) => {
          const active = item.isActive(pathname);
          return (
            <li key={item.id}>
              <Link
                to={item.to}
                activeOptions={{ exact: true }}
                aria-current={active ? "page" : undefined}
                className={sectionNavItemClassName(active)}
              >
                <item.icon className="size-4 shrink-0 opacity-80" aria-hidden />
                {item.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
